import React from "react";
import { BiSolidVolumeFull, BiSolidVolumeLow } from "react-icons/bi";
import { Button } from "./MuteButton.styled";

const MuteButton = ({ volume, onToggleVolume }) => {
  return (
    <Button onClick={onToggleVolume}>
      {volume === 0.1 ? <BiSolidVolumeLow /> : <BiSolidVolumeFull />}
    </Button>
  );
};

export default MuteButton;
